module.exports = __webpack_public_path__ + "assets/images/1-3Ka8_yM.jpg";